import React, {useState} from "react";
import {useTranslation} from 'gatsby-plugin-react-i18next';

export const SearchForm = ({ onSend, cssClass, placeholder }) => {
  const {t} = useTranslation();

  const [query, setQuery] = useState("");

  const handleChange = (event) => {
    setQuery( query => {
      const value = event.target.value;
      onSend(event, value);
      return value
    });

  }

  const handleSubmit = (event) => {
    event.preventDefault();
    onSend(event, query);
  }

  return (
    <form onSubmit={handleSubmit} className={`position-relative ${cssClass}`}>
      <input value={query} onChange={handleChange} name="search-project" placeholder={t(placeholder)} type="text" className="form-control" />
      <button type="submit" className="btn btn-white position-absolute subscribe-form__btn">{t("Search")}</button>
    </form>
  );
}
